import UiTooltip from '../UiTooltip.vue';

export default {
    props: {
        tooltip: String,
        tooltipPosition: String
    },

    components: {
        UiTooltip
    }
};



/** WEBPACK FOOTER **
 ** ./src/mixins/ShowsTooltip.js
 **/